import React, { useState, useEffect, useRef } from 'react';
import { Dropdown } from 'react-bootstrap';
import { useLocation } from 'react-router-dom';
import { useCustomTableDispatch } from 'store/hooks/customTable';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';

import {
  ALERTING_TALBE_COLUMNS,
  ALL_LIVE_TALBE_COLUMNS,
  ALL_TALBE_COLUMNS,
  CUSTOM_LIVE_TABLE_FILTER,
  CUSTOM_TABLE_FILTER,
  EMPTY_ARRAY,
  FILTER_KEYS,
  GAME,
  LIVE_ALERTING_TABLE_FILTER,
} from '../../../../config/constants';
import { isBrownsUser, isCC, isIn, routeToSpecificScope } from '../../../../helpers';
import { useDataEventsState,  useFiltersState, useUserState } from '../../../../store/hooks';
import { ParamWrapper } from '../ParamWrapper';
import { CustomTableFilterItem, CustomTableFilterParamsType, CustomTableFilterWrappedParamsType,  CustomTableFilterDataType, CustomTableHeaderOptionsType, CustomTablesHeaderType} from './types';
import { useRouter } from 'helpers/customHooks';
import { PerformanceRoutes } from 'components/Viewer/TabPerformance/types';

const CustomTableFilterWrapped = ({
                                 changeFilterDataWrapped,
                                 forceScope,
                                 show,
                                 close,
                                 open,
                                 customLoad,
                                 setShowFilter,
                                 liveTab,
                                 alerting,
                                 accountPage,
                                 editable,
                                 closeAlert
                               }: CustomTableFilterWrappedParamsType) => {    
  const { pathname } = useLocation();
  const { dataEvent: data } = useDataEventsState();
  const { eventType } = useRouter<PerformanceRoutes>();
  const rendersCounter = useRef(0);
  const user = useUserState();
  const { updateCustomTable } = useCustomTableDispatch();
  const [closed, setClosed] = useState(false);
  const [allSelected, setAllSelected] = useState(false);
  const specificScope = forceScope || routeToSpecificScope(pathname);
  const scope = specificScope;
  const filterCustom: CustomTableFilterDataType = [];
  const filterSelected: CustomTableHeaderOptionsType = [];
  const [filterCustomCopy, setFilterCustomCopy] = useState<CustomTableFilterDataType>(filterCustom);
  const [filterSelectedCopy, setFilterSelectedCopy] = useState<CustomTableHeaderOptionsType>(filterSelected);
  const [filterSelectedPrev, setFilterSelectedPrev] = useState<CustomTableHeaderOptionsType>(filterSelectedCopy);
  let FILTER_CONSTANT:CustomTablesHeaderType = [];
  if(alerting){
    FILTER_CONSTANT = LIVE_ALERTING_TABLE_FILTER;
  }
  else if(liveTab){
    FILTER_CONSTANT = CUSTOM_LIVE_TABLE_FILTER;
  }else{
    FILTER_CONSTANT = CUSTOM_TABLE_FILTER;
  }
  const [dragableContent, setDragableContent] = useState(FILTER_CONSTANT);
  const [dragableCopy, setDragableCopy] = useState(FILTER_CONSTANT);
  let browns12Label = false;
  if (isBrownsUser(user)) {
    browns12Label = true;
  } else if (eventType === GAME && data.meta.homeTeam.teamId === '1050' && isCC(user)) {
    browns12Label = true;
  }

  useEffect(() => {
    customLoad?.forEach((data:string, index)=>{
      filterCustom.push({name: data});
      const nameSelected = FILTER_CONSTANT.find(e=>e.key === data)?.label;
      filterSelected.push({key: data , label: nameSelected? nameSelected : '' });
    });
    if(filterCustom.length === FILTER_CONSTANT.length){
      setAllSelected(true);
    };
    setDragableContent(dragableCopy.filter(item => !customLoad?.includes(item.key)));
    changeFilterDataWrapped(filterCustom,)();
    setFilterCustomCopy(filterCustom);
    setFilterSelectedCopy(filterSelected);
    setFilterSelectedPrev(filterSelected);
  }, [customLoad]);

  
  const reorder = (list:CustomTableHeaderOptionsType | undefined, startIndex: number, endIndex: number)=>{
    if(list){
      const result = [...list];
      const [removed] = result.splice(startIndex, 1);
      result.splice(endIndex, 0, removed);
      return result;
    }else{
      return [];
    }
  };

  const reorderSelected = (list:CustomTableFilterItem[] | undefined, startIndex: number, endIndex: number)=>{
    if(list){
      const startTrueIndex = startIndex > list.length-1? list.length-1 : startIndex;
      const endTrueIndex = endIndex > list.length-1? list.length-1 : endIndex;
      const result = [...list];
      const [removed] = result.splice(startTrueIndex, 1);
      result.splice(endTrueIndex, 0, removed);
      const cleanResult = result.filter(element =>{
        return element !== undefined;
      });
      return cleanResult;
    }else{
      return [];
    }
  };

  const { [liveTab? FILTER_KEYS.CUSTOM_LIVE_TABLE : FILTER_KEYS.CUSTOM_TABLE]: filterData = alerting? customLoad || EMPTY_ARRAY : EMPTY_ARRAY} = useFiltersState(specificScope, 
    liveTab? FILTER_KEYS.CUSTOM_LIVE_TABLE : FILTER_KEYS.CUSTOM_TABLE);

  const [newPositionsSelected, setNewPositionsSelected] = useState<CustomTableFilterItem[]>(
    filterCustom);
  const [newPositionsSelectedCopy, setNewPositionsSelectedCopy] = useState(newPositionsSelected);
  const updatePositionSelectedState = (newCopyPositionsSelected: CustomTableFilterItem[], itsAll?: boolean) => {
    setNewPositionsSelectedCopy([...newCopyPositionsSelected]);
    setAllSelected(alerting? newCopyPositionsSelected.length === FILTER_CONSTANT.length : 
      liveTab? newCopyPositionsSelected.length === ALL_LIVE_TALBE_COLUMNS.length : newCopyPositionsSelected.length === ALL_TALBE_COLUMNS.length);
    if(itsAll){
      setFilterSelectedCopy(FILTER_CONSTANT);
      setDragableContent([]);
    }
  };

  useEffect(() => {
    rendersCounter.current++;
    if(rendersCounter.current > 1){
      if(!closed){
      changeFilterDataWrapped(dragableContent.every((key => (isIn(newPositionsSelectedCopy, {
                name: key.key
              })))) && !allSelected ? [] : newPositionsSelectedCopy,)();
            }
  }
  }, [dragableContent, newPositionsSelectedCopy]);

  useEffect(() => {
    rendersCounter.current++;
    if(setShowFilter === -1 && rendersCounter.current > 2){
        handleSave();
    }
  }, !alerting? [setShowFilter]:[]);

  const handleCloseAlert = ()=>{
    setFilterSelectedCopy(filterSelectedPrev);
    setDragableContent(dragableCopy.filter(item => !customLoad?.includes(item.key)));
    if(closeAlert)closeAlert();
    };

  const addPosition = (args: CustomTableFilterItem[]) => {
    let newCopyPositionsSelected = [...newPositionsSelectedCopy];
    let newCopyfilterSelected = [...filterSelectedCopy];
    let newDragableCopy = [...dragableContent];
    args.forEach((position) => {      
      if (isIn(newCopyPositionsSelected, position)) {
        newCopyPositionsSelected = newCopyPositionsSelected.filter(pos => (pos.name !== position.name));
        newCopyfilterSelected = newCopyfilterSelected.filter(pos => (pos.key !== position.name));
        const nameSelected = FILTER_CONSTANT.find(e=>e.key === position.name)?.label;
        const indexOf = FILTER_CONSTANT.findIndex(e => e.key === position.name);
        newDragableCopy.splice(indexOf,0,{label: nameSelected? nameSelected :'' , key:position.name});
      } else {
        newCopyPositionsSelected.push(position);
        const nameSelected = FILTER_CONSTANT.find(e=>e.key === position.name)?.label;
        newCopyfilterSelected.push({label:nameSelected? nameSelected :'', key: position.name});
        newDragableCopy = newDragableCopy.filter(pos=>(pos.key !== position.name));
      }
    });
      setDragableContent(newDragableCopy);
      setFilterSelectedCopy(newCopyfilterSelected);
      updatePositionSelectedState(newCopyPositionsSelected);
  };
  const NEW_POSTIONS:string[] = [];
  const handleSave = () =>{
    newPositionsSelectedCopy.forEach(data =>{
      if(data)NEW_POSTIONS.push(data.name);
    });
    if(!alerting){
      updateCustomTable(NEW_POSTIONS, user.email, liveTab);
      
    }
    setFilterCustomCopy(newPositionsSelectedCopy); 
  };
  const selected: JSX.Element[] = [];
  
  filterSelectedCopy.forEach((data, index)=>{
    selected.push(
      <Draggable key={data.key} draggableId={data.key} index={index} isDragDisabled={alerting}>
          {(draggableProvider) =>(
          <div 
          {...draggableProvider.draggableProps}
          ref={draggableProvider.innerRef}
          {...draggableProvider.dragHandleProps}
          className="p-b-02"
          id={data.key}
          >
         <input
         className="styled-checkbox" id={scope + data.key}
         checked={isIn(newPositionsSelectedCopy, {name: data.key})}
         type="checkbox"
         value={data.key}
         onChange={() => addPosition([{name: data.key}])}
       />
       <label
         htmlFor={scope + data.key}
         id={scope + data.key + '-label'}
         style={{ fontWeight: isIn(newPositionsSelectedCopy, {name: data.key}) ? 'bold' : undefined }}
         className="check-l"
       >
         { data.label ===  'YDS 10+'?  browns12Label? 'YDS 12+' : data.label :
           data.label ===  'Time 10+'? browns12Label? 'Time 12+' : data.label : data.label}
       </label>
       </div>
          )  
        }
    </Draggable>
    );
  });
  
  const groups: JSX.Element[] = [];
  dragableContent.forEach((data, index) => {
      groups.push(
             <div 
             className="p-b-02"
             id={data.key}
             key={data.key}
             >
            <input
            className="styled-checkbox" id={scope + data.key}
            checked={isIn(newPositionsSelectedCopy, {name: data.key})}
            type="checkbox"
            value={data.key}
            onChange={() => addPosition([{name: data.key}])}
          />
          <label
            htmlFor={scope + data.key}
            id={scope + data.key + '-label'}
            style={{ fontWeight: isIn(newPositionsSelectedCopy, {name: data.key}) ? 'bold' : undefined }}
            className="check-l"
          >
            { data.label ===  'YDS 10+'?  browns12Label? 'YDS 12+' : data.label :
              data.label ===  'Time 10+'? browns12Label? 'Time 12+' : data.label : data.label}
          </label>
          </div>
         
      );
    });

  const onOpen = () => {
    
    setClosed(false);
    const customAlert = customLoad?.map(data=>{
      return {name: data};
    });
    updatePositionSelectedState(
      alerting? customAlert? customAlert : [] : filterData);
    open();
  };
  
  return (
    <Dropdown className="custom-table-dropdown" show={show} onToggle={show ? alerting? handleCloseAlert : close : onOpen} style={alerting? accountPage? 
    {marginTop:'-34px', marginRight: '5px', zIndex: 305 } :  {marginTop:'-34px', marginRight: '50px', zIndex: 305 }:{} }>
      <Dropdown.Toggle id="dropdown-basic-custom-table" className="mdi mdi-ballot-outline btn-gray-l" style={{width: '80px', fontSize:'21px'}} disabled={alerting && !editable}/>
      <Dropdown.Menu>
      <div className="p-h-01-custom">
          Select All
          <div className="p-i-01-custom">
            <input
              type="checkbox" id={'custom-table-all-selected'} name="set-name" className="switch-input"
              checked={allSelected}
              onChange={() => {
                if (allSelected) {
                  setAllSelected(false);
                  changeFilterDataWrapped([])();
                  setNewPositionsSelectedCopy([]);
                  updatePositionSelectedState([]);
                  setDragableContent(FILTER_CONSTANT);
                  setFilterSelectedCopy([]);               
                } else {
                  const positionArrayConstant = (alerting? ALERTING_TALBE_COLUMNS : liveTab? ALL_LIVE_TALBE_COLUMNS : ALL_TALBE_COLUMNS);
                  const positionsSelected = new Set(newPositionsSelectedCopy.map(pos => pos.name));
                  const filteredPositionArray = positionArrayConstant.filter(pos => !positionsSelected.has(pos));
                  const removedPositions = positionArrayConstant.filter(pos => positionsSelected.has(pos));
                  const finalFilteredPositions = removedPositions.concat(filteredPositionArray);
                  updatePositionSelectedState(finalFilteredPositions.map(position => ({
                    name: position
                  })), true);
                  setAllSelected(true);
                }
              }}
            />
            <label htmlFor={'custom-table-all-selected'} id={'custom-table-all-selected-label'} className="switch-label" />
          </div>
        </div>
      <DragDropContext onDragEnd={(result)=> {
        const {source, destination} = result;
        if(!destination || (source.index === destination.index && source.droppableId === destination.droppableId)){
          return;
        }
        setFilterSelectedCopy((prevState) => reorder(prevState, source.index, destination.index));
        setNewPositionsSelectedCopy((prevState)=>reorderSelected(prevState, source.index, destination.index));
      }}>
      <Droppable droppableId="Custom-Rows" isDropDisabled={alerting}>
          {(droppableProvider)=>(
            <>
             <div className="p-b-01"
             {...droppableProvider.droppableProps}
             ref={droppableProvider.innerRef}>
            <div 
            className="p-b-02-custom">
              {selected}
              
            {droppableProvider.placeholder}
          </div>
            <div>
          {groups}
          </div>
          
          </div>
        </>
         )}
         </Droppable>
         </DragDropContext>
         { alerting?
         <div className="footer-s">
          <button className="btn-transparet" onClick={handleCloseAlert}>Cancel</button>
          <button
            className={'btn-blue '}
            onClick={close}
          >
           Apply
          </button>
        </div>: null}
      </Dropdown.Menu>
    </Dropdown>
  );
};

const CustomTableFilter = (props: CustomTableFilterParamsType) => {
  return (
    <ParamWrapper
      fromUrlSearchParam={() => []}
      toUrlSearchParam={() => ''}
      Component={CustomTableFilterWrapped}
      props={props}
      filterKey={props.liveTab? FILTER_KEYS.CUSTOM_LIVE_TABLE : FILTER_KEYS.CUSTOM_TABLE}
    />
  );
};

export default CustomTableFilter;
export * from './types';